export const ptBR = {
  mainTitle: "Quem bebe?",
  menu: {
    home: "Home",
    wheel: "Roleta de Shots",
    lottery: "Sorteio bêbado",
    neverHave: "Eu nunca",
    fingerSelector: "Dedo podre",
    whereIsIt: "Onde está?",
    simon: "Copia-me",
    image: "WhoDrinks Logo",
  },
  mobileMenu: {
    home: "Home",
    wheel: "Roleta de Shots",
    lottery: "Sorteio bêbado",
    neverHave: "Eu nunca",
    fingerSelector: "Dedo podre",
    whereIsIt: "Onde está?",
    simon: "Copia-me",
  },
  footer: {
    message: {
      firstPart: "Feito com",
      secondPart: "por MicroChanges.",
    },
  },
  modal: {
    title: "Que beleza!! =)",
    description:
      "{drawn} foi @ grande sortead@ da rodada! Preparem uma bela dose de felicidade para ess@ sortud@!",
    notify:
      "{drawn} foi @ grande sortead@ da rodada! Preparem uma bela dose de felicidade para ess@ sortud@!",
    closeButton: "Fechar",
  },
  socialFooter: {
    title: "Compartilhe",
  },
  home: {
    title: "Quem bebe?",
    subtitle: "Bora tomar uma!",
    image: "Pessoas bebendo",
    wheelButton: "Roleta de shots",
    lotteryButton: "Sorteio bêbado",
    neverHaveButton: "Eu nunca",
    fingerSelectorButton: "Dedo podre",
    whereIsItButton: "Onde está?",
    simonButton: "Copia-me",
    description:
      "Alguma crítica ou sugestão? Clica na bolinha amarela na parte de baixo da tela e manda uma mensagem pra gente =)",
    installLabel: {
      firstPart: "Clique",
      secondPart: "aqui",
      thirdPart: "para instalar o App!",
    },
    games: "Escolha o jogo",
    howto: "Como jogar"
  },
  wheel: {
    mainPage: {
      title: "Quem bebe?",
      wheelButton: "Girar roleta!",
      renameLink: "Renomear espaços",
      wheelSpaces: {},
      firstSlot: "Beba um shot",
      secondSlot: "Dance uma música",
      thirdSlot: "Passe a vez",
      fourthSlot: "Escolha um amigo para beber",
      fifthSlot: "Beba e gire mais uma vez",
      sixthSlot: "Beba sem usar as mãos",
      seventhSlot: "Beba em dobro",
      eighthSlot: "Todos bebem menos você",
    },
    renamePage: {
      inputLabel: "Participante ou prêmio",
      inputPlaceholder: "Preencha com um participante ou um prêmio",
      saveButton: "Salvar",
    },
  },
  lottery: {
    mainPage: {
      title: "Quem bebe?",
      subtitle: "Sorteando próxima dose em:",
      configLink: "Alterar configurações de sorteio",
      tableHeader: "Participantes",
      stopLotteryLink: "Parar sorteio",
    },
    configPage: {
      title: "Quem bebe?",
      subtitle: "Insira as configurações para o sorteio",
      inputTimeLabel: "Tempo entre os sorteios (em minutos):",
      inputTimePlaceholder: "Digite o tempo entre os sorteios",
      inputMemberLabel: "Participantes:",
      inputMemberPlaceholder: "Digite o nome de um participante",
      validateLotteryTime: "É necessário preencher o tempo entre os sorteios",
      validateMemberList: "É necessário inserir algum nome na lista",
      saveButton: "Salvar",
    },
  },
  neverHave: {
    title: "Quem bebe?",
    initialPhrase: "Clique em um dos botões para sortear uma frase.",
    gentleButton: "Leves",
    controversyButton: "Polêmicas",
    embarrassingButton: "Pesadas 18+",
    spicyButton: "Picante 18+",
  },
  fingerSelector: {
    title: "Quem bebe?",
    centralMessage: {
      restart: "Aperta aqui para reiniciar",
      pressScreen: "Pressione a tela",
      anotherFinger: "Mais um dedo para iniciar a contagem",
    },
  },
  simon: {
    nextRoundButton: "Próxima rodada",
    nextMatchButton: "Próxima partida",
    startRoundButton: "Iniciar próxima rodada",
    startMatchButton: "Iniciar partida",
    matchWinner:
      "Você venceu! Prepare uma belíssima dose de felicidade para o seu oponente. =)",
    matchLoser:
      "Você perdeu. Para refrescar a sua mente, tome uma belíssima dose de felicidade. =)",
    roundWinner:
      "Parabéns! Você venceu essa rodada. Prepare-se para a próxima rodada!",
    roundLoser:
      "Uma pena, você perdeu essa rodada. Concentre-se para vencer a próxima rodada.",
    centralMessage: {
      go: "Valendo!",
    },
  },
  whereIsIt: {
    levels: {
      easy: "Fácil",
      medium: "Médio",
      hard: "Difícil",
      impossible: "Impossível",
    },
    guideMessage: {
      selectTheLevel: "Selecione o modo de jogo",
      youWin: "Você venceu! Sem doses dessa vez =)",
      youLose: "Você perdeu! Tome uma dose para refrescar a mente =)",
    },
    restartButton: "Reiniciar jogo",
  },
  howToPlayBackDrop: {
    title: "Como jogar",
    tips: {
      wheel: "Esse é moleza! Escolha um bebedor e manda ver na roleta. O escolhido faz o que for sorteado.",
      lottery: "Chama a galera e vamos ver quem é o mais sortudo. Preencha o formulário com os participantes e o tempo de sorteio. Assim que acabar o tempo, um dos participantes será sorteado e terá que beber um bela dose de bebida.",    
      badPicker: "O escolhido! Basta colocar mais de um dedo na tela para começar a contagem. Ao final da contagem, um dos dedos será o sorteado da rodada.",
      whereIsIt: "Será que você é bom o bastante? Basta selecionar a dificuldade para que o jogo comece. Procure o copo vazio e fique de olho para onde ele vai. Os copos irão se embaralhar por um tempo até que parem. Caso você acerte o copo vazio, parabéns! Você passou ileso nessa rodada. Mas caso você erre... Tome um belo shot =)",
      simon: "É hora do duelo! Desafie alguém para jogar contra você. Ao iniciar o jogo, a máquina escolherá uma sequência aleatória de cores. Aguarde o contador zerar e faça exatamente a mesma sequência de cores que o computador fez para ser o vencedor! Quem vencer dois jogos primeiro é o vencedor do duelo.",
      neverHave: "Eu nunca! Aperte o botão que deseja para escolher um nível de frase. Fale a frase em voz alta. Quem já fez o que está escrito na frase toma uma dose.",
    },
  },
  gamesBackdrop: {
    title: "Escolha o jogo",
  },
};
